import React from 'react';
import Classes from './CancelConfirmPopup.module.css';
import { motion } from 'framer-motion';

export default function CancelConfirmPopup({ handleClose, handleSubmit }) {
  const handleBgClick = () => {};
  const handleCardClick = (event) => { event.stopPropagation(); }

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.2 }}
      className={Classes.popup} onClick={handleBgClick}>
      <motion.div initial={{ y: -7 }} animate={{ y: 0 }} exit={{ y: 7 }} transition={{ duration: 0.25 }}
        className={Classes.card} onClick={handleCardClick}>
        <div className={Classes.close} onClick={handleClose}>
          <svg xmlns="http://www.w3.org/2000/svg" height='25px' fill='white' viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" /></svg>
        </div>
        <div className={Classes.bgPopup}>
          <div></div>
          <svg xmlns="http://www.w3.org/2000/svg" height='40px' fill='white' viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" /></svg>
          <div className={Classes.curveCon}></div>
        </div>
        <div className={Classes.cardCon}>
          <h5 className={Classes.title2}>Are you sure you want to cancel?</h5>
          <div className={Classes.placeholder}>This action can’t be undone.</div>
          <div className={Classes.flexAlign} style={{ marginTop: '2rem' }}>
            <button type="button" onClick={handleClose} className={Classes.btn1}><h5>Cancel</h5></button>
            <button type="button" onClick={handleSubmit} className={Classes.btn2}><h5>Submit</h5></button>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}
